var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Flex, Radio, Typography } from '@robinpowered/ui-kit';
import { ConflictDetail } from './ConflictDetail';
/**
 * A labelled group of selectable time suggestions (e.g. "Everyone is
 * available" / "Some conflicts").
 */
export var SuggestionSection = function (_a) {
    var token = _a.token, label = _a.label, suggestions = _a.suggestions, selectedId = _a.selectedId;
    return (_jsxs(Flex, { vertical: true, gap: 8, children: [_jsx(Typography.Text, { style: { color: token.colorTextSecondary }, children: label }), suggestions.map(function (suggestion) { return (
            // The whole card is a <label> for the radio inside, so clicking
            // anywhere selects it while staying keyboard-focusable and announced
            // by screen readers (selection flows through the parent Radio.Group).
            _jsxs(SuggestionCard, { token: token, selected: selectedId === suggestion.id, children: [_jsx(Radio, { value: suggestion.id, children: suggestion.label }), suggestion.conflicts.length > 0 && (_jsx(ConflictDetail, { token: token, conflicts: suggestion.conflicts }))] }, suggestion.id)); })] }));
};
var SuggestionCard = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 12px 16px;\n  border-radius: ", "px;\n  border: 1px solid\n    ", ";\n  cursor: pointer;\n\n  .ant-radio-wrapper {\n    margin-inline-end: 0;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 12px 16px;\n  border-radius: ", "px;\n  border: 1px solid\n    ", ";\n  cursor: pointer;\n\n  .ant-radio-wrapper {\n    margin-inline-end: 0;\n  }\n"])), function (_a) {
    var token = _a.token;
    return token.borderRadius;
}, function (_a) {
    var token = _a.token, selected = _a.selected;
    return selected ? token.colorPrimary : token.colorBorderSecondary;
});
var templateObject_1;
